<template>
  <b-modal
    centered
    id="maker-device-ass"
    modal-class="overflow-hidden"
    static
    scrollable
    ignore-enforce-focus-selector="input"
  >
    <template #modal-header="">
      <h5>Xác nhận gán TB cho MC</h5>
      <b-button size="sm" variant="light" @click="closeModalMaker()"> x </b-button>
    </template>
    <form @submit.prevent="updateInfo">
      <div>
        <div class="form-group">
          <label
            >Bạn có chắc chắn đã gán thiết bị {{ serial.serial }} cho Merchant: {{ emailMC }}</label
          >
        </div>
      </div>
    </form>
    <template #modal-footer>
      <b-button
        class="btn-style"
        size="sm"
        type="button"
        variant="light"
        @click="closeModalMaker()"
      >
        Hủy bỏ
      </b-button>
      <b-button class="btn-style" type="submit" size="sm" variant="primary" @click="updateInfo()">
        Xác nhận
      </b-button>
    </template>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </b-modal>
</template>

<script>
  import { TicketService } from '@/services/ticket.service'
  export default {
    name: 'modal-maker-device-ass',
    props: {
      ticketId: {
        type: String,
      },
      emailMC: {
        type: String,
      },
      dataMakerDevice: {
        type: Object,
      },
      closeModalMaker: {
        type: Function,
      },
    },
    data() {
      return {
        showLoading: false,
        serial: '',
      }
    },
    created() {
      this.handleDeviceData()
    },
    methods: {
      handleDeviceData() {
        const { assNewTestDevice, assReplaceDevice, deviceChange, deviceTest } =
          this.dataMakerDevice

        if (assNewTestDevice != null && assReplaceDevice != null) {
          if (assNewTestDevice === false && assReplaceDevice === false) {
            this.serial = {
              serial: deviceTest.serial,
              typeUsage: 'TEST',
            }
          } else if (assNewTestDevice === false && assReplaceDevice === true) {
            this.serial = {
              serial: deviceTest.serial,
              typeUsage: 'TEST',
            }
          } else if (assNewTestDevice === true && assReplaceDevice === false) {
            this.serial = {
              serial: deviceChange.serial,
              typeUsage: 'SELL',
            }
          } else {
            this.serial = '...'
          }
        }
      },
      async updateInfo() {
        try {
          this.showLoading = true
          const params = {
            typeUsage: this.serial.typeUsage,
            ticketId: this.ticketId,
          }
          const data = await TicketService.makerDevice(params)
          if (data.code === 1000) {
            this.showSuccessMx('Xác nhận gán thiết bị cho MC thành công')
            this.$emit('updateInfoMakerDevice')
          } else this.showFailMx(data.message)
        } catch (error) {
          this.showFailMx(error.message)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style scoped>
  .btn-style {
    border-radius: 0.25rem;
    line-height: 1.5;
    padding: 0.4rem 0.75rem;
    font-weight: 400;
    margin: 0.25rem;
  }
  .div-btn {
    text-align: right;
  }
</style>
